import editSignalIntervals from './actions/EditSignalIntervals/texts.js';
import exportTexts from './actions/ExportCsv/texts.js';
import hideSignals from './actions/HideSignals/texts.js';
import showSignals from './actions/ShowSignals/texts.js';
import startExciterExpertAnalysis from './actions/StartExciterExpertAnalysis/texts.js';

export default {
  histogram: {
    header: {
      notes: 'Header in histogram section',
      message: 'Histogram',
    },
    remainder: {
      notes: 'Label of remainder segment in histograms',
      message: 'Remainder',
    },
    toggleButton: {
      tooltip: {
        notes: 'Tooltip for button showing / hiding histogram',
        message: 'Histogram',
      },
    },
  },
  table: {
    header: {
      notes: 'Header in tabular data section',
      message: 'Tabular data',
    },
    time: {
      notes: 'Text in column header for timestamp when showing tabular data',
      message: 'Time',
    },
    toggleButton: {
      tooltip: {
        notes: 'Tooltip for button showing / hiding tabular data in charts',
        message: 'Show data in table',
      },
    },
  },
  timeline: {
    duration: {
      lasted: {
        notes:
          'Text before user friendly duration. Example of duration: "5 hours 12 minutes"',
        message: 'Lasted',
      },
    },
  },
  lineSeries: {
    tooltip: {
      x: {
        notes: 'Label used for x-axis in tooltip',
        message: 'X:',
      },
      y: {
        notes: 'Label used for y-axis in tooltip',
        message: 'Y:',
      },
    },
  },
  zoom: {
    reset: {
      notes: 'Text on button to reset zoom',
      message: 'Reset',
    },
  },
  signalIntervals: {
    upper: {
      notes: 'Label for upper bound of a signal interval',
      message: 'Upper',
    },
    lower: {
      notes: 'Label for lower bound of a signal interval',
      message: 'Lower',
    },
  },
  action: {
    hideSignals,
    showSignals,
    minmax: {
      tooltip: {
        notes: 'Tooltip for action to show min and max values in charts',
        message: 'Show min/max values',
      },
      tooltipDisabled: {
        notes:
          'Tooltip for action to show min and max values in chart when disabled',
        message: 'Min/max values not available for data set',
      },
    },
    events: {
      tooltip: {
        notes:
          'Tooltip for action to show events (alarms, annotations, ...) in charts',
        message: 'Show events',
      },
    },
    addAnnotation: {
      notes: 'Label for add annotation action',
      message: 'Add annotation',
    },
    grouped: {
      tooltip: {
        notes: 'Grouped mode for bar charts',
        message: 'Grouped',
      },
    },
    stacked: {
      tooltip: {
        notes: 'Stacked mode for bar charts',
        message: 'Stacked',
      },
    },
    signalIntervals: {
      tooltip: {
        notes: 'Tooltip for action to show thresholds in chart',
        message: 'Show thresholds',
      },
    },
    editSignalIntervals,
    startExciterExpertAnalysis,
    export: exportTexts,
    valueRepresentation: {
      absolute: {
        tooltip: {
          notes: 'Tooltip for action to show absolute values in chart',
          message: 'Absolute values',
        },
      },
      relative: {
        tooltip: {
          notes: 'Tooltip for action to show relative values in chart',
          message: 'Relative values',
        },
      },
    },
    zoomIn: {
      notes: 'Label for zoom in action',
      message: 'Zoom in',
    },
    requestHighResolutionData: {
      notes: 'Label for action to request downloading high resolution data',
      message: 'Fetch high-resolution data',
    },
  },
  eventTimeline: {
    alarmTrack: {
      label: {
        notes: 'Label for alarm track in event timeline',
        message: 'Alarm',
      },
    },
    annotationTrack: {
      label: {
        notes: 'Label for annotation track in event timeline',
        message: 'Annotation',
      },
    },
  },
  selection: {
    zoomIn: {
      tooltip: {
        notes: 'Tooltip for zoom in mode when dragging',
        message: 'Drag to zoom mode',
      },
    },
    selection: {
      tooltip: {
        notes: 'Tooltip for select mode when dragging',
        message: 'Drag to select mode',
      },
    },
  },
  compare: {
    time: {
      current: {
        notes:
          'Label for group of current plots when using time compare in charts',
        message: 'Current',
      },
      previous: {
        notes:
          'Label for group of previous plots when using time compare in charts',
        message: 'Previous',
      },
    },
  },
  legend: {
    highResolutionPeriod: {
      notes: 'Legend label for plotting high resolution availability periods',
      message: 'High resolution period',
    },
    unavailableGroup: {
      notes: 'Group name for plot which are not applicable',
      message: 'Not applicable',
    },
  },
  dataResolution: {
    aggregated: {
      notes: 'Name of aggregated data resolution',
      message: 'Aggregated',
    },
    highResolution: {
      notes: 'Name of high resolution data resolution',
      message: 'High resolution',
    },
  },
  tooltip: {
    highResolutionAvailable: {
      notes: 'Label shown in tooltip when high resolution data exists',
      message: 'High-resolution data available',
    },
    highResolutionUnavailable: {
      notes:
        'Label shown in tooltip when no high resolution data exists for current time',
      message: 'High-resolution data not available',
    },
    highResolutionRequested: {
      notes:
        'Label shown in tooltip when high resolution data is being requested',
      message: 'High-resolution data requested',
    },
  },
};
